import * as React from "react";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";

import Layout from "../Layouts/MasterLayout/MasterLayout";
import SEO from "../components/SEO/Seo";

import "../components/Polos/Polos.css";

export default function PolosPage() {
	const [poloGaleria, setPoloGaleria] = React.useState(null);
	const [imagemAtiva, setImagemAtiva] = React.useState(0);

	const abrirGaleria = (polo) => {
		setPoloGaleria(polo);
		setImagemAtiva(0);
	};

	const fecharGaleria = () => {
		setPoloGaleria(null);
		setImagemAtiva(0);
	};

	const imagemAnterior = () => {
		if (!poloGaleria?.image?.length) return;

		setImagemAtiva((atual) =>
			atual === 0 ? poloGaleria.image.length - 1 : atual - 1
		);
	};

	const proximaImagem = () => {
		if (!poloGaleria?.image?.length) return;

		setImagemAtiva((atual) =>
			atual === poloGaleria.image.length - 1 ? 0 : atual + 1
		);
	};

	React.useEffect(() => {
		if (!poloGaleria) return undefined;

		const aoPressionarTecla = (event) => {
			if (event.key === "Escape") fecharGaleria();
			if (event.key === "ArrowLeft") imagemAnterior();
			if (event.key === "ArrowRight") proximaImagem();
		};

		document.addEventListener("keydown", aoPressionarTecla);
		document.body.style.overflow = "hidden";

		return () => {
			document.removeEventListener("keydown", aoPressionarTecla);
			document.body.style.overflow = "";
		};
	}, [poloGaleria]);

	const conteudo = [
		{
			title: "Campo Bom",
			location:
				"Av. Edgar Hoffmeister, 500, Zona Industrial Norte, Campo Bom – RS. Prédio do Câmpus III, piso 0 - sala 003.",
			image: [
				{
					src: "https://www.feevale.br/Comum/midias/55df2a51-613f-4105-af1a-1d1478e78e9d.jpg",
					alt: "Image 1",
				},
			],
			phone: "(51) 3586.8800, ramal 6939",
			gotoUrl: "https://maps.app.goo.gl/M9KZTAsq7XrCHLZE7",
		},
		{
			title: "Esteio",
			location: "Rua Engenheiro Hener de Souza Nunes, 102, Centro, Esteio, RS.",
			image: [
				{
					src: "https://www.feevale.br/Comum/midias/447d1357-799c-4aec-b5aa-31a3d7b6c1d3.png",
					alt: "Image 1",
				},
				{
					src: "https://www.feevale.br/Comum/midias/759c60a4-4dcb-48f2-95cd-f82ce1377495.png",
					alt: "Image 2",
				},
				{
					src: "https://www.feevale.br/Comum/midias/06e0e0e9-67b4-4cf3-bf8f-5b17d2a8e9f0.png",
					alt: "Image 3",
				},
				{
					src: "https://www.feevale.br/Comum/midias/38aae3d4-8449-41d8-8c25-af099e3a8002.jpg",
					alt: "Image 4",
				},
				{
					src: "https://www.feevale.br/Comum/midias/4c6e5bee-86c9-41aa-a6a0-2900ced0d966.png",
					alt: "Image 5",
				},
				{
					src: "https://www.feevale.br/Comum/midias/d03a42d0-8d03-4f0f-bc78-88580ab354fa.png",
					alt: "Image 6",
				},
			],
			phone: "(51) 3586.8800, ramal 6934",
			galleryUrl:
				"https://www.flickr.com/photos/fotosfeevale/albums/72157707862652065",
			gotoUrl:
				"https://www.google.com/maps?ll=-29.853058,-51.178413&z=15&t=m&hl=pt-BR&gl=BR&mapclient=embed&q=R.+Eng.+Hener+de+Souza+Nunes,+102+-+Centro+Esteio+-+RS+93260-120",
			capacidade:
				"Capacidade sala Digital: 18 lugares.<br/>Capacidade sala Tutoria: 8 lugares.",
		},
		{
			title: "Gramado",
			location: "Rua São Pedro, 532, Centro, Gramado, RS.",
			image: [
				{
					src: "https://www.feevale.br/Comum/midias/2ef2de61-3afd-42f0-a4a3-f3d60cf1e178.png",
					alt: "Image 1",
				},
				{
					src: "https://www.feevale.br/Comum/midias/6560324f-1aa9-494a-af09-882c0a7b16c5.jpg",
					alt: "Image 2",
				},
				{
					src: "https://www.feevale.br/Comum/midias/f22440f4-3bb9-4dfb-94f7-1e8fd4402e5d.jpg",
					alt: "Image 3",
				},
				{
					src: "https://www.feevale.br/Comum/midias/2a9d33e8-64c4-440a-b16e-1c18df8a18a7.jpg",
					alt: "Image 4",
				},
				{
					src: "https://www.feevale.br/Comum/midias/e3b7b67f-bc07-4fce-97d4-085439ce44d8.png",
					alt: "Image 5",
				},
			],
			phone: "(51) 3586.8800, ramal 6941",
			galleryUrl:
				"https://www.flickr.com/photos/fotosfeevale/albums/72157716568856993",
			gotoUrl:
				"https://www.google.com/maps?ll=-29.377219,-50.876061&z=15&t=m&hl=pt-BR&gl=BR&mapclient=embed&q=R.+S%C3%A3o+Pedro,+532+-+Centro+Gramado+-+RS+95670-000",
			capacidade:
				"Capacidade sala Digital: 18 lugares.<br/>Capacidade sala Tutoria: 8 lugares.",
		},
		{
			title: "Igrejinha",
			location: "Rua João Corrêa, 548, Centro, Igrejinha, RS.",
			image: [
				{
					src: "https://www.feevale.br/Comum/midias/efc4c915-b832-4dd3-a6b4-0f574bbb39ab.jpeg",
					alt: "Image 1",
				},
				{
					src: "https://www.feevale.br/Comum/midias/ecd62950-d55a-4511-8821-132a84db154b.jpeg",
					alt: "Image 2",
				},
				{
					src: "https://www.feevale.br/Comum/midias/63c37d60-463b-4588-a33a-4de9f31801bc.jpeg",
					alt: "Image 3",
				},
				{
					src: "https://www.feevale.br/Comum/midias/26afaa4a-a28d-4d2c-9061-71ff58f72d1d.jpg",
					alt: "Image 4",
				},
				{
					src: "https://www.feevale.br/Comum/midias/b154fa3f-5565-4ed7-8a2a-c726dca0339e.jpeg",
					alt: "Image 5",
				},
				{
					src: "https://www.feevale.br/Comum/midias/ecd4e8f9-9a48-471c-8dc7-06033b6d08d4.jpeg",
					alt: "Image 6",
				},
				{
					src: "https://www.feevale.br/Comum/midias/b54359c5-d66e-4948-9551-51e6ca9eae54.jpeg",
					alt: "Image 7",
				},
				{
					src: "https://www.feevale.br/Comum/midias/0f8162e4-1be1-44f9-9a0c-d51045a2587b.jpg",
					alt: "Image 8",
				},
			],
			phone: "(51) 3586.8800, ramal 6935",
			galleryUrl:
				"https://www.flickr.com/photos/fotosfeevale/albums/72157708304862984",
			gotoUrl:
				"https://www.google.com/maps?ll=-29.57333,-50.790307&z=15&t=m&hl=pt-BR&gl=BR&mapclient=embed&q=R.+Jo%C3%A3o+Corr%C3%AAa,+548+-+Centro+Igrejinha+-+RS+95650-000",
			capacidade:
				"Capacidade sala Digital: 26 lugares.<br/>Capacidade sala Tutoria: 8 lugares.",
		},
		{
			title: "Montenegro",
			location: "Rua João Pessoa, 1.415, Centro, Montenegro, RS.",
			image: [
				{
					src: "https://www.feevale.br/Comum/midias/b1ccd942-cbf6-42bf-a49d-3982a8d21e52.jpeg",
					alt: "Image 1",
				},
				{
					src: "https://www.feevale.br/Comum/midias/30099f42-2e2e-4fb3-9d25-ec80543d95b1.jpeg",
					alt: "Image 2",
				},
				{
					src: "https://www.feevale.br/Comum/midias/478f51b6-8256-400b-9010-5a18e2260f41.jpg",
					alt: "Image 3",
				},
				{
					src: "https://www.feevale.br/Comum/midias/6120ab9b-a595-4ac0-8303-4be57346dd43.jpg",
					alt: "Image 4",
				},
				{
					src: "https://www.feevale.br/Comum/midias/b5dbde45-b0de-4cd6-a19b-97c152b1f060.jpg",
					alt: "Image 5",
				},
				{
					src: "https://www.feevale.br/Comum/midias/214bdd92-7580-47f4-a80e-459b9c1dc38b.jpg",
					alt: "Image 6",
				},
			],
			phone: "(51) 3586.8800, ramal 6937",
			galleryUrl:
				"https://www.flickr.com/photos/fotosfeevale/albums/72157716568856993",
			gotoUrl:
				"https://www.google.com/maps?ll=-29.688776,-51.460699&z=15&t=m&hl=pt-BR&gl=BR&mapclient=embed&q=R.+Jo%C3%A3o+Pessoa,+1415+-+Centro+Montenegro+-+RS+95780-000",
			capacidade:
				"Capacidade sala Digital: 20 lugares.<br/>Capacidade sala Tutoria: 8 lugares.",
		},
		{
			title: "Nova Petrópolis",
			location:
				"Avenida 15 de Novembro, n° 664 - Centro, Nova Petrópolis - RS, 95150-000. ",
			image: [
				{
					src: "https://www.feevale.br/s/conteudo/dc8d6c6b-c84a-4d03-8b3b-79f2ba640b03/logo_polo.png",
					alt: "Image 1",
				},
			],
			phone: "(51) 3586.8800, ramal 6942",
			galleryUrl:
				"https://www.flickr.com/photos/fotosfeevale/albums/72157716568856993",
			gotoUrl:
				"https://www.google.com/maps/place/Avenida+15+de+Novembro,+664+-+Centro,+Nova+Petr%C3%B3polis+-+RS,+95150-000/@-29.3815418,-51.1203954,17z/data=!3m1!4b1!4m10!1m2!2m1!1sAvenida+15+de+Novembro,+664-+Centro!3m6!1s0x951eb3733b52e237:0x6d65e395a6eb0718!8m2!3d-29.3815419!4d-51.115782!15sCiNBdmVuaWRhIDE1IGRlIE5vdmVtYnJvLCA2NjQtIENlbnRyb5IBCnN1YnByZW1pc2XgAQA!16s%2Fg%2F11kj00fgkr?hl=pt-BR&entry=ttu&g_ep=EgoyMDI2MDYwMy4xIKXMDSoASAFQAw%3D%3D",
			capacidade:
				"Capacidade sala Digital: 32 lugares.<br/>Capacidade sala Tutoria: 8 lugares.",
		},
		{
			title: "Novo Hamburgo (Câmpus II)",
			location: "ERS-239, 2755, Novo Hamburgo, RS. Prédio Rosa - sala 105.",
			galleryUrl:
				"https://www.feevale.br/institucional/infraestrutura/campus-ii",
			image: [
				{
					src: "https://www.feevale.br/Comum/midias/96b2031e-d2f1-4d73-86a2-1460868a19c7.jpg",
					alt: "Image 1",
				},
				{
					src: "https://www.feevale.br/Comum/midias/bd25cdf1-8eca-43fd-bee8-f7c063c1b6b3.jpg",
					alt: "Image 2",
				},
				{
					src: "https://www.feevale.br/Comum/midias/cc73b551-de23-432d-ac39-575a06f82a13.jpg",
					alt: "Image 3",
				},
				{
					src: "https://www.feevale.br/Comum/midias/5b9a5a96-fc19-42ef-a637-c0121e8753b1.jpg",
					alt: "Image 4",
				},
				{
					src: "https://www.feevale.br/Comum/midias/7fd75ec4-3394-4c21-8d17-5848c83b42c0.jpg",
					alt: "Image 5",
				},
				{
					src: "https://www.feevale.br/Comum/midias/b10e0490-cd74-4149-8aca-74845b212128.jpg",
					alt: "Image 6",
				},
			],
			phone: "(51) 3586.8800, ramal 6932",
			gotoUrl:
				"https://www.google.com/maps?ll=-29.662867,-51.118253&z=15&t=m&hl=pt-BR&gl=BR&mapclient=embed&cid=13895729503577414069",
		},
		{
			title: "Sapiranga",
			location: "Av. 20 de Setembro, 4733, São Jacó, Sapiranga, RS.",
			image: [
				{
					src: "https://www.feevale.br/Comum/midias/2fd6d339-0a41-4a35-a62d-cbc06d6f4706.jpg",
					alt: "Image 1",
				},
				{
					src: "https://www.feevale.br/Comum/midias/cc678bfa-5dec-412a-b313-2259f7b732a6.jpg",
					alt: "Image 2",
				},
				{
					src: "https://www.feevale.br/Comum/midias/e3760c29-5648-4580-9761-845348f03dd4.jpg",
					alt: "Image 3",
				},
				{
					src: "https://www.feevale.br/Comum/midias/e324ebb3-15a7-4bcc-a2ed-d45491a51b33.jpg",
					alt: "Image 4",
				},
				{
					src: "https://www.feevale.br/Comum/midias/346704a3-cbaa-45e5-ba89-1b5eec996210.jpg",
					alt: "Image 5",
				},
				{
					src: "https://www.feevale.br/Comum/midias/f58ca665-f812-478b-86bd-605b1b90e083.jpg",
					alt: "Image 6",
				},
			],
			phone: "(51) 3586.8800, ramal 6933",
			galleryUrl:
				"https://www.flickr.com/photos/fotosfeevale/albums/72157709426145136",
			gotoUrl:
				"https://www.google.com/maps?ll=-29.632151,-50.999069&z=15&t=m&hl=pt-BR&gl=BR&mapclient=embed&q=Av.+20+de+Setembro,+4733+-+S%C3%A3o+Jaco+Sapiranga+-+RS+93815-016",
			capacidade:
				"Capacidade sala Digital: 32 lugares.<br/>Capacidade sala Tutoria: 8 lugares.",
		},
		{
			title: "Porto Alegre - Hub One",
			location: "R. Cândido Silveira, 198 - Auxiliadora, Porto Alegre - RS.",
			image: [
				{
					src: "https://www.feevale.br/Comum/midias/1def4054-857e-46bc-b3b4-16d8a618c0f1.jpg",
					alt: "Image 1",
				},
				{
					src: "https://www.feevale.br/Comum/midias/77b5242b-1ba1-4478-8536-0cb162b97711.jpg",
					alt: "Image 2",
				},
				{
					src: "https://www.feevale.br/Comum/midias/df20a9a4-a063-418b-84d9-44ff4c46b921.jpg",
					alt: "Image 3",
				},
				{
					src: "https://www.feevale.br/Comum/midias/327b21a5-5882-40e6-9fad-a6575c2578f2.jpg",
					alt: "Image 4",
				},
				{
					src: "https://www.feevale.br/Comum/midias/5a3a6cc5-e6f9-43cb-9579-546b026e9fa5.jpg",
					alt: "Image 5",
				},
				{
					src: "https://www.feevale.br/Comum/midias/503c75ee-b2ca-49e0-b6ed-2fdae5abc6d8.jpeg",
					alt: "Image 6",
				},
				{
					src: "https://www.feevale.br/Comum/midias/7b1ca023-707f-4ec0-bacf-c9045e942c65.jpeg",
					alt: "Image 7",
				},
				{
					src: "https://www.feevale.br/Comum/midias/37b335f6-3b8b-4cb7-9a78-50bb8630676e.jpeg",
					alt: "Image 8",
				},
				{
					src: "https://www.feevale.br/Comum/midias/f1e0fa86-1a3f-4678-ba04-46ecf43c1cb4.jpg",
					alt: "Image 9",
				},
			],
			phone: "(51) 3586.8800, ramal 6940",
			galleryUrl:
				"https://feevaletechpark.com.br/unidades-parque-tecnologico/feevale-techpark-hub-one-porto-alegre/",
			gotoUrl: "https://goo.gl/maps/AnAzpnwektivXSPJ7",
			capacidade:
				"Capacidade Espaço Talk: 16 lugares.<br/>Capacidade sala Digital: 8 lugares.<br/>Capacidade sala Tutoria: 2 lugares.",
		},
	];


	return (
		<>
			<SEO
				title="Polos da Universidade Feevale"
				description="Conheça os polos da Universidade Feevale e toda infraestrutura na região."
			/>

			<Layout color="#fff">
				<main className="polosPage">
					<section className="polosPage-intro">
						<MDBContainer>
							<span className="polosPage-eyebrow">UNIVERSIDADE FEEVALE</span>
							<h1>POLOS FEEVALE</h1>
							<p>
								Encontre o polo mais próximo de você e conheça os espaços,
								estrutura e canais de atendimento disponíveis.
							</p>
						</MDBContainer>
					</section>

					<section className="polosPage-lista">
						<MDBContainer>
							<MDBRow>
								{conteudo.map((polo, index) => {
									const imagemCapa = polo.image?.[0];

									return (
										<MDBCol
											key={polo.title}
											xs="12"
											md="6"
											lg="4"
											className="d-flex mb-4"
										>
											<article className="polosCard">
												{imagemCapa && (
													<button
														type="button"
														className="polosCard-imagemWrap"
														onClick={() => abrirGaleria(polo)}
														aria-label={`Ver fotos do Polo Feevale ${polo.title}`}
													>
														<img
															src={imagemCapa.src}
															alt={`Polo Feevale ${polo.title}`}
															className="polosCard-imagem"
															loading={index < 2 ? "eager" : "lazy"}
															decoding="async"
														/>

														{polo.image?.length > 1 && (
															<span className="polosCard-fotosBadge">
																+{polo.image.length - 1} fotos
															</span>
														)}
													</button>
												)}

												<div className="polosCard-conteudo">
													<span className="polosCard-rotulo">POLO FEEVALE</span>
													<h2>{polo.title}</h2>

													<div className="polosCard-info">
														<div className="polosCard-infoItem">
															<i className="fas fa-map-marker-alt" aria-hidden="true" />
															<p>{polo.location}</p>
														</div>

														<div className="polosCard-infoItem">
															<i className="fas fa-phone-alt" aria-hidden="true" />
															<p>{polo.phone}</p>
														</div>

														{polo.capacidade && (
															<div className="polosCard-infoItem">
																<i className="fas fa-users" aria-hidden="true" />
																<div
																	className="polosCard-capacidade"
																	dangerouslySetInnerHTML={{
																		__html: polo.capacidade,
																	}}
																/>
															</div>
														)}
													</div>

													<div className="polosCard-acoes">
														<a
															href={polo.gotoUrl}
															target="_blank"
															rel="noreferrer"
															className="polosCard-btn polosCard-btn--principal"
														>
															Como chegar
															<i className="fas fa-arrow-right" aria-hidden="true" />
														</a>

														{polo.image?.length > 1 && (
															<button
																type="button"
																className="polosCard-btn polosCard-btn--secundario polosCard-btn--galeria"
																onClick={() => abrirGaleria(polo)}
															>
																Ver fotos
															</button>
														)}
													</div>
												</div>
											</article>
										</MDBCol>
									);
								})}
							</MDBRow>
						</MDBContainer>
					</section>

					{poloGaleria && (
						<div
							className="polosGaleria"
							role="dialog"
							aria-modal="true"
							aria-label={`Galeria de fotos do Polo ${poloGaleria.title}`}
							onMouseDown={(event) => {
								if (event.target === event.currentTarget) fecharGaleria();
							}}
						>
							<div className="polosGaleria-dialog">
								<div className="polosGaleria-header">
									<div>
										<span>POLO FEEVALE</span>
										<h2>{poloGaleria.title}</h2>
									</div>

									<button
										type="button"
										className="polosGaleria-fechar"
										onClick={fecharGaleria}
										aria-label="Fechar galeria"
									>
										×
									</button>
								</div>

								<div className="polosGaleria-principal">
									<img
										src={poloGaleria.image[imagemAtiva].src}
										alt={
											poloGaleria.image[imagemAtiva].alt ||
											`Foto ${imagemAtiva + 1} do Polo ${poloGaleria.title}`
										}
										decoding="async"
									/>

									{poloGaleria.image.length > 1 && (
										<>
											<button
												type="button"
												className="polosGaleria-nav polosGaleria-nav--anterior"
												onClick={imagemAnterior}
												aria-label="Foto anterior"
											>
												‹
											</button>

											<button
												type="button"
												className="polosGaleria-nav polosGaleria-nav--proxima"
												onClick={proximaImagem}
												aria-label="Próxima foto"
											>
												›
											</button>
										</>
									)}

									<span className="polosGaleria-contador">
										{imagemAtiva + 1} / {poloGaleria.image.length}
									</span>
								</div>

								{poloGaleria.image.length > 1 && (
									<div className="polosGaleria-miniaturas">
										{poloGaleria.image.map((imagem, index) => (
											<button
												type="button"
												key={`${poloGaleria.title}-${index}`}
												className={`polosGaleria-miniatura ${
													index === imagemAtiva
														? "polosGaleria-miniatura--ativa"
														: ""
												}`}
												onClick={() => setImagemAtiva(index)}
												aria-label={`Abrir foto ${index + 1}`}
											>
												<img
													src={imagem.src}
													alt=""
													loading="lazy"
													decoding="async"
												/>
											</button>
										))}
									</div>
								)}

								<div className="polosGaleria-footer">
									<a
										href={poloGaleria.gotoUrl}
										target="_blank"
										rel="noreferrer"
										className="polosGaleria-mapa"
									>
										Como chegar
									</a>

									{poloGaleria.galleryUrl && (
										<a
											href={poloGaleria.galleryUrl}
											target="_blank"
											rel="noreferrer"
											className="polosGaleria-linkExterno"
										>
											Ver galeria externa
										</a>
									)}
								</div>
							</div>
						</div>
					)}
				</main>
			</Layout>
		</>
	);
}
